import { SupersetClient } from '@aibi-ui/core';
import rison from 'rison';

/** *************************** 校区 **************************** */
// 分页获取校区列表
export const getCampusListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/campus/record', searchParams });

// 新增校区
export const postCampusAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/campus/record', jsonPayload });

// 更新校区
export const putCampusAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/campus/record', jsonPayload });

// 更新校区状态
export const putCampusStatusAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/campus/record/status', jsonPayload });

// 删除校区
export const deleteCampusAPI = async campusId =>
  SupersetClient.put({ endpoint: `/api/v1/campus/${campusId}` });

/** *************************** 院系 **************************** */
// 分页获取院系列表 系通过faulty_type区分
export const getFacultyListAPI = async searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/department/faculty/record',
    searchParams,
  });

// 新增院系
export const postFacultyAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/department/faculty', jsonPayload });

// 编辑院系
export const putFacultyAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/department/faculty', jsonPayload });

// 更新院系状态
export const putFacultyStatusAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/department/faculty/status',
    jsonPayload,
  });

// 根据id获取院系详情
export const getFacultyDetailAPI = async searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/department/faculty/detail',
    searchParams,
  });

/** *************************** 专业 **************************** */
// 分页获取专业列表
export const getMajorListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/major/record', searchParams });

// 新增专业
export const postMajorAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/major/record', jsonPayload });

// 编辑专业
export const putMajorAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/major/record', jsonPayload });

// 更新专业状态
export const putMajorStatusAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/major/record/status', jsonPayload });

/** *************************** 班级 **************************** */
// 分页获取班级列表
export const getClazzListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/clazz/record', searchParams });

// 新增班级
export const postClazzAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/clazz/record', jsonPayload });

// 编辑班级
export const putClazzAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/clazz/record', jsonPayload });

// 更新班级状态
export const putClazzStatusAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/clazz/record/status', jsonPayload });

// 删除班级
export const deleteClazzAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/clazz/record/${id}` });

/** *************************** 组织 **************************** */
// 分页获取部门列表
export const getOrganizationListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/department/record', searchParams });

// 新增部门
export const postOrganizationAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/department/record', jsonPayload });

// 编辑部门
export const putOrganizationAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/department/record', jsonPayload });

// 删除部门
export const deleteOrganizationAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/department/record/${id}` });

/** *************************** 职位 **************************** */
// 分页获取职位列表
export const getPositionListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/position/record', searchParams });

// 新增职位
export const postPositionAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/position/record', jsonPayload });

// 编辑职位
export const putPositionAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/position/record', jsonPayload });

// 删除职位
export const deletePositionAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/position/record/${id}` });

/** *************************** 用户 **************************** */
// 查询所有用户
export const getUserListAPI = (q = '') =>
  SupersetClient.get({ endpoint: `/api/v1/security/users/?${q}` });

// 分页获取教师用户列表
export const getTeacherUserListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/user/teacher/record', searchParams });

// 新增教师账号
export const postTeacherUserAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/user/teacher/record', jsonPayload });

// 编辑教师账号
export const putTeacherUserAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/user/teacher/record', jsonPayload });

// 教师用户批量更新状态
export const putTeacherStatusAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/user/teacher/record/active',
    jsonPayload,
  });

// 教师用户重置密码
export const putTeacherPasswordAPI = async id =>
  SupersetClient.put({ endpoint: `/api/v1/user/teacher/record/reset/${id}` });

// 删除教师用户
export const deleteTeacherUserAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/user/teacher/record/${id}` });

// 分页获取学生用户列表
export const getStudentUserListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/user/student/record', searchParams });

// 新增学生账号
export const postStudentUserAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/user/student/record', jsonPayload });

// 编辑学生账号
export const putStudentUserAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/user/student/record', jsonPayload });

// 学生用户批量更新状态
export const putStudentStatusAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/user/student/record/active',
    jsonPayload,
  });

// 学生用户重置密码
export const putStudentPasswordAPI = async id =>
  SupersetClient.put({ endpoint: `/api/v1/user/student/record/reset/${id}` });

// 删除学生账号
export const deleteStudentUserAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/user/student/record/${id}` });

/** *************************** 角色 **************************** */
// 分页查询角色列表
export const getRoleListAPI = async searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/security/roles/record',
    searchParams,
  });

// 新增角色
export const postRoleAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/security/roles/record',
    jsonPayload,
  });

// 修改角色
export const putRoleAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/security/roles/record',
    jsonPayload,
  });

// 删除角色
export const deleteRoleAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/security/roles/record/${id}` });

// 批量删除角色
export const deleteRoleBatchAPI = async jsonPayload =>
  SupersetClient.delete({
    endpoint: `/api/v1/security/roles/record/batch/delete`,
    jsonPayload,
  });

// 分页获取角色用户
export const getRoleUserListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/security/roles/user', searchParams });

/** *************************** 行级权限 **************************** */
// 获取行级权限列表
export const getRowPermissionListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/rowlevelsecurity/', searchParams });

/** 行级权限获取给定数据集可访问的角色
 * @returns {Promise<import('@aibi-ui/core').JsonResponse<{result: import('src/types/Role').Role[]}>>}
 */
export const getRowPermissionRoleListAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/rowlevelsecurity/permed_roles',
    jsonPayload,
  });

// 新增行级权限
export const postRowPermissionAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/rowlevelsecurity/', jsonPayload });

// 编辑行级权限
export const putRowPermissionAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: `/api/v1/rowlevelsecurity/${jsonPayload.id}`,
    jsonPayload,
  });

// 删除指定行级权限
export const deleteRowPermissionAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/rowlevelsecurity/${id}` });

// 修改行级权限状态
export const postRowPermissionStatusAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/rowlevelsecurity/switch',
    jsonPayload,
  });

/** *************************** 列级权限 **************************** */
// 获取列级权限
export const getColumnPermissionListAPI = async searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/columnlevelsecurity/',
    searchParams,
  });

// 新增列级权限
export const postColumnPermissionAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/columnlevelsecurity/',
    jsonPayload,
  });

// 更新列级权限
export const putColumnPermissionAPI = async jsonPayload => {
  SupersetClient.put({
    endpoint: `/api/v1/columnlevelsecurity/${jsonPayload.id}`,
    jsonPayload,
  });
};

// 获取数据集的角色
export const getDatasetRoleListAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/columnlevelsecurity/permed_roles',
    jsonPayload,
  });

// 删除列级权限
export const deleteColumnsPermissionAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/columnlevelsecurity/${id}` });

// 启用/禁用列级权限
export const postColumnPermissionStatusAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/columnlevelsecurity/switch',
    jsonPayload,
  });

/** *************************** 数据集 **************************** */
// 获取数据集
export const getDatasetListAPI = async searchParams =>
  SupersetClient.get({
    endpoint: `/api/v1/dataset/`,
    searchParams: {
      q: rison.encode_uri({
        page: 0,
        page_size: 10000,
        filters: [{ col: 'sql', opr: 'dataset_is_null_or_empty', value: true }],
        ...searchParams,
      }),
    },
  });

// 获取数据集详情
export const getDatasetDetailAPI = async (
  id,
  q = { with_responsible: 1, with_role: true },
) =>
  SupersetClient.get({
    endpoint: `/api/v1/dataset/${id}`,
    searchParams: { q: rison.encode_uri(q) },
  });

/**
 * 获取我的数据集列表
 * @param {Object} searchParams
 * @returns
 */
export const getDatasetOwnerRecordAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/dataset/owner/record',
    searchParams,
  });

/**
 * 修改数据集责任人/所有者
 * @param {Object} jsonPayload 请求参数
 * @param {number[]} jsonPayload.custom_owner_user 所有者用户id列表
 * @param {number[]} jsonPayload.responsible_personel_user 责任人用户id列表
 * @param {number} jsonPayload.id 数据集id
 */
export const putDatasetUserAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/dataset/dataset/user', jsonPayload });

/**
 * 修改数据集角色
 * @param {Object} jsonPayload
 * @param {number[]} jsonPayload.ids  数据集id列表
 * @param {number[]} jsonPayload.role_ids 角色id列表
 */
export const putDatasetRoleAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/dataset/dataset/role', jsonPayload });

/** *************************** 主题设置 **************************** */
/**
 * 分页获取主题列表
 * @param {*=} searchParams
 * @returns
 */
export const getTopicRecordAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/topic/record', searchParams });

/** 新增主题 */
export const postTopicRecordAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/topic/record', jsonPayload });
/** 修改主题 */
export const putTopicRecordAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/topic/record', jsonPayload });

/**
 * 批量删除主题
 * @param {Object} jsonPayload 请求参数
 * @param {Array<Number>} jsonPayload.ids id列表
 * @returns
 */
export const deleteTopicRecordAPI = jsonPayload =>
  SupersetClient.delete({
    endpoint: '/api/v1/topic/record',
    jsonPayload,
  });

/**
 * 修改主题排序
 * @param {Objcet} jsonPayload
 * @param {Array<{id: number; sort: number}>} jsonPayload.list
 * @returns
 */
export const putTopicRecordSortAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/topic/record/sort', jsonPayload });

/** *************************** 图表 **************************** */
// 获取图表详情
export const getChartDetailAPI = async id =>
  SupersetClient.get({ endpoint: `/api/v1/explore/?slice_id=${id}` });

// 获取图表数据
export const getChartDataAPI = async ({ searchParams, jsonPayload }) =>
  SupersetClient.post({
    endpoint: '/api/v1/chart/data',
    searchParams,
    jsonPayload,
  });

/** *************************** 模型渠道 **************************** */
// 获取模型渠道列表
export const getModelChannelListAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/channel/record', searchParams });

// 新增模型渠道
export const postModelChannelAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/channel/record', jsonPayload });

// 修改模型渠道
export const putModelChannelAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/channel/record', jsonPayload });

// 修改模型渠道状态
export const putModelChannelStatusAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/channel/record/status',
    jsonPayload,
  });

// 删除模型渠道
export const deleteModelChannelAPI = id =>
  SupersetClient.delete({ endpoint: `/api/v1/channel/record/${id}` });

// 批量修改模型渠道排序
export const putModelChannelPriorityAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/channel/record/priority',
    jsonPayload,
  });

/** *************************** 模型配置 **************************** */
// 获取模型配置列表
export const getModelSetListAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/pattern/record', searchParams });

// 新增模型配置
export const postModelSetAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/pattern/record', jsonPayload });

// 修改模型配置
export const putModelSetAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/pattern/record', jsonPayload });

// 修改模型配置状态
export const putModelSetStatusAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/pattern/record/status',
    jsonPayload,
  });

// 删除模型配置状态
export const deleteModelSetAPI = id =>
  SupersetClient.delete({ endpoint: `/api/v1/pattern/record/${id}` });

// 设为默认
export const putDefaultModelAPI = id =>
  SupersetClient.put({ endpoint: `/api/v1/pattern/record/pattern/${id}` });

/** *************************** 调用日志 **************************** */
// 分页获取token调用记录
export const getTokenUseListAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/tokenusage/record', searchParams });

// 获取总调用数据
export const getAllTokenUseAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/tokenusage/usage/total',
    searchParams,
  });

// 获取各渠道/模型调用数据
export const getTokenByModelOrChannelListAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/tokenusage/usage/list',
    searchParams,
  });

// 获取调用数据（图表用）
export const getTokenChartDataAPI = type =>
  SupersetClient.get({ endpoint: `/api/v1/tokenusage/usage/tables/${type}` });

/** *************************** 术语库 **************************** */
/** 分页查询术语库 */
export const getParlanceRecordAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/parlance/record', searchParams });

/** 新增术语库 */
export const postParlanceAddAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/parlance/add', jsonPayload });

/** 修改术语库 */
export const putParlanceEditAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/parlance/edit', jsonPayload });

/**
 * 批量删除术语
 * @param {Number[]} jsonPayload
 * @returns
 */
export const deleteParlanceAPI = jsonPayload =>
  SupersetClient.delete({ endpoint: '/api/v1/parlance/delete', jsonPayload });

/** *************************** 业务偏好 **************************** */
/** 分页查询业务偏好 */
export const getPreferenceRecordAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/businesspreference/record',
    searchParams,
  });

/** 新增业务偏好 */
export const postPreferenceAddAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/businesspreference/add',
    jsonPayload,
  });

/** 修改业务偏好 */
export const putPreferenceEditAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/businesspreference/edit',
    jsonPayload,
  });

/**
 * 批量删除业务偏好
 * @param {Number[]} jsonPayload
 * @returns
 */
export const deletePreferenceAPI = jsonPayload =>
  SupersetClient.delete({
    endpoint: '/api/v1/businesspreference/delete',
    jsonPayload,
  });

/** *************************** 代码示例 **************************** */
/** 分页查询代码示例 */
export const getCodeExampleRecordAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/codeexample/record',
    searchParams,
  });

/** 新增代码示例 */
export const postCodeExampleAddAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/codeexample/add',
    jsonPayload,
  });

/** 修改代码示例 */
export const putCodeExampleEditAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/codeexample/edit',
    jsonPayload,
  });

/**
 * 批量删除代码示例
 * @param {Number[]} jsonPayload
 * @returns
 */
export const deleteCodeExampleAPI = jsonPayload =>
  SupersetClient.delete({
    endpoint: '/api/v1/codeexample/delete',
    jsonPayload,
  });

/** *************************** 思路配置 **************************** */
/** 分页查询思路配置 */
export const getThinkConfigRecordAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/thinkconfig/record',
    searchParams,
  });

/** 新增思路配置 */
export const postThinkConfigAddAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/thinkconfig/add',
    jsonPayload,
  });

/** 修改思路配置 */
export const putThinkConfigEditAPI = jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/thinkconfig/edit',
    jsonPayload,
  });

/**
 * 批量删除思路配置
 * @param {Number[]} jsonPayload
 * @returns
 */
export const deleteThinkConfigAPI = jsonPayload =>
  SupersetClient.delete({
    endpoint: '/api/v1/thinkconfig/delete',
    jsonPayload,
  });
